import React from 'react';
import {InputMask} from "primereact/inputmask";
import clsx from "clsx";
import {INPUT_PLACEHOLDERS} from "../../types";

const InputPhone = (
  {
    id,
    name,
    placeholder = INPUT_PLACEHOLDERS.PHONE,
    onChange,
    className,
    error
  }: {
  id?: string;
  name?: string;
  placeholder?: string;
  className?: string;
  onChange: any;
  error?: string | boolean;

}) => {
  return (
    <div className="relative">
      <InputMask
        id={id}
        name={name}
        mask="99999999999"
        onChange={onChange}
        placeholder={placeholder}
        className={
          clsx(
            "block w-[200px] py-[7px] border border-solid border-mainBlack/10 px-2 outline-none text-black rounded-sm text-sm leading-[16px]",
            className
          )
        }
      />
      {error && <span className="absolute bottom-[-15px] text-rose-700 text-xs">{error}</span>}
    </div>
  )
}

export default InputPhone;
